import React from 'react';
import useCollectionState from 'Hooks/useCollectionState';

/**
 * usePaginatedCollectionState
 *
 * Provides an interface for fetching/maintain a collection by facet rest
 */
const usePaginatedCollectionState = (args) => {
  const collectionStateValues = useCollectionState(args);
  const {
    collection,
    fetchCollectionByLink,
  } = collectionStateValues;

  const hasNextPage = React.useCallback(() => {
    return !!collection?.link('next');
  }, [collection]);

  const hasPrevPage = React.useCallback(() => {
    return !!collection?.link('prev');
  }, [collection]);

  const getNextPage = React.useCallback((fetchArgs) => {
    if (collection && hasNextPage()) {
      return fetchCollectionByLink(collection.link('next'), fetchArgs);
    }
    return undefined;
  }, [hasNextPage, collection, fetchCollectionByLink]);

  const getPrevPage = React.useCallback((fetchArgs) => {
    if (collection && hasPrevPage()) {
      return fetchCollectionByLink(collection.link('prev'), fetchArgs);
    }
    return undefined;
  }, [hasPrevPage, collection, fetchCollectionByLink]);

  return {
    ...collectionStateValues,
    hasPrevPage: hasPrevPage(),
    hasNextPage: hasNextPage(),
    getPrevPage,
    getNextPage,
  };
};

export default usePaginatedCollectionState;
